import SubscribeForm from '@/src/components/ui/subscribeForm/SubscribeForm';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import styles from './SimpleSubscribe.module.scss';

const SimpleSubscribe = () => {
  return (
    <Wrapper>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <h2 className={styles.title}>Be the First to Know</h2>
          <p className={styles.desc}>
            New theme releases, performance updates, store growth guides, and curated industry
            resources — delivered to your inbox before everyone else.
          </p>
        </div>
        <SubscribeForm colorScheme="light" />
      </div>
    </Wrapper>
  );
};

export default SimpleSubscribe;
